export default {
    api_url: 'https://ahrefs.goodtobebad.xyz/api',
    ws:{
        host:'ahrefs.goodtobebad.xyz',
        port:'6616'
    }
}
